import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Routes from '../../app/routes';
import { DateTime } from '../datetime/datetime';
import { FormGroup } from 'shared-components';
import styles from './task.module.css';
import { useDeleteTaskMutation, useGetTaskQuery } from './tasks.api';
import { Card, CardContent } from 'shared-components';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import { TextArea } from 'shared-components';
import { Input } from 'shared-components';
import { PageTitle } from 'shared-components';

export const Task = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const [deleteTask] = useDeleteTaskMutation();
  const { data, isFetching, isLoading } = useGetTaskQuery(id ?? '');
  if (isLoading || isFetching || !data) {
    return <p>Loading...</p>;
  }
  return (
    <>
      <PageTitle
        title="Task"
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.TASKS.title, link: Routes.TASKS.link },
          {
            display: data?._id.toString() ?? '',
            link: Routes.TASK.createLink?.(id as string) ?? '',
          },
        ]}
        allowDelete={true}
        onAction={async (action) => {
          switch (action) {
            case 'delete':
              // eslint-disable-next-line no-restricted-globals
              if (confirm('Are you sure you want to delete this task?')) {
                await deleteTask(id as string);
                toast.success('Task deleted');
                navigate(Routes.TASKS.link);
              }
              break;
          }
        }}
      />
      <Card className={styles.taskForm}>
        <CardContent>
          <FormLayout>
            <FormGroup className={styles.created}>
              <Label htmlFor="created">Created on</Label>
              <p>
                <DateTime d={data.created_on} />
              </p>
            </FormGroup>
            <FormGroup className={styles.status}>
              <Label htmlFor="status">Status</Label>
              <Input
                readOnly
                disabled
                type="text"
                id="status"
                value={data.status}
              />
            </FormGroup>
            <FormGroup className={styles.type}>
              <Label htmlFor="type">Type</Label>
              <Input
                readOnly
                disabled
                type="text"
                id="type"
                value={data.type}
              />
            </FormGroup>
            <FormGroup className={styles.subType}>
              <Label htmlFor="subType">Sub-type</Label>
              <Input
                readOnly
                disabled
                type="text"
                id="subType"
                value={data.subtype}
              />
            </FormGroup>
            <FormGroup className={styles.notes}>
              <Label htmlFor="notes">Notes</Label>
              <TextArea readOnly disabled id="notes" value={data.notes} />
            </FormGroup>
            <FormGroup className={styles.payload}>
              <Label htmlFor="payload">Payload</Label>
              <TextArea
                readOnly
                disabled
                id="payload"
                value={JSON.stringify(data.payload, null, 2)}
              />
            </FormGroup>
          </FormLayout>
        </CardContent>
      </Card>
    </>
  );
};
